import axios from '../http'


function get(id) {
    return axios.get('/event/raceBoat/get?id=' + id);
}

function adjustSeq(data) {
    return axios.post('/event/raceBoat/adjustSeq', data);
}

function chooseChannel(data) {
    return axios.post('/event/raceBoat/chooseChannel', data);
}

function adjustLane(data) {
    return axios.post('/event/raceBoat/adjustLane', data);
}

function adjustComp(data) {
    return axios.post('/event/raceBoat/adjustComp', data);
}

function clear(data) {
    return axios.post('/event/raceBoat/clear', data);
}

function begin(data) {
    return axios.post('/event/raceBoat/begin', data);
}
function end(data) {
    return axios.post('/event/raceBoat/end', data);
}

function penaltyTime(data) {
    return axios.post('/event/raceBoat/penaltyTime', data);
}

function confirm(data) {
    return axios.post('/event/raceBoat/confirm', data);
}

function dns(data) {
    return axios.post('/event/raceBoat/dns', data);
}

function dnf(data) {
    return axios.post('/event/raceBoat/dnf', data);
}

function exc(data) {
    return axios.post('/event/raceBoat/exc', data);
}

function dsq(data) {
    return axios.post('/event/raceBoat/dsq', data);
}

function findCandidateByProjectId(projectId) {
    return axios.get('/event/raceBoat/findCandidateByProjectId?projectId=' + projectId);
}

function findByRaceId(raceId) {
    return axios.get('/event/raceBoat/findByRaceId?raceId=' + raceId);
}

export default {
    get,
    adjustSeq,
    adjustComp,
    chooseChannel,
    adjustLane,
    clear,
    begin,
    end,
    confirm,
    dns,
    dnf,
    exc,
    dsq,
    penaltyTime,
    findCandidateByProjectId,
    findByRaceId

}